import type { CompetitionStageDetailed, UpdateCompetitionStageRequest } from '@clsplus/api-types/api-admin'

import { getTokens } from '../../helpers/auth'

export function updateCompetitionStageDetails(
  competitionId: string,
  stageId: string,
  formData: UpdateCompetitionStageRequest
): Promise<CompetitionStageDetailed> {
  const tokens = getTokens()

  return fetch(`${import.meta.env.VITE_API_URL}admin/competitions/${competitionId}/competition-stages/${stageId}`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${tokens?.accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw new Error(data.error)
      }

      return data
    })
}
